export default __webpack_public_path__ + "static/media/4_4.6dc6bd22.png";